// Lazy loader for @amplitude/session-replay-browser (~190kB minified, it
// bundles an rrweb recorder). Loading it on demand keeps it out of the
// render-blocking vendor chunk: it is only needed once a signup replay
// trigger event fires (see startSessionReplay.ts).
type SessionReplayModule = typeof import('@amplitude/session-replay-browser');

let loadedModule: SessionReplayModule | undefined;

export const loadSessionReplayModule =
  async (): Promise<SessionReplayModule> => {
    loadedModule ??= await import('@amplitude/session-replay-browser');
    return loadedModule;
  };

// Both helpers are no-ops until the module is loaded. This matches the SDK
// behavior before init() is called: getSessionReplayProperties() returns {}
// and shutdown() does nothing.
export const getSessionReplayProperties = (): Record<string, unknown> =>
  loadedModule?.getSessionReplayProperties() ?? {};

export const shutdownSessionReplay = (): void => {
  loadedModule?.shutdown();
};
